import React, { useState, useRef } from "react";

//styles
import styles from "./autocomplete.module.scss";

const data = [
  {
    code: 1,
    title: "Delivery via CD",
  },
];

const CustomAutoComplete = ({
  name,
  placeholder,
  value,
  onChange,
  error,
  type,
  onEnter,
}) => {
  const inputRef = useRef(null);
  const [list, setList] = useState([]);
  const [focused, setFocused] = useState(false);

  const handleList = async () => {
    let payload = [];

    return new Promise((resolve) => {
      data.forEach((d) => {
        const title = d.title.toLowerCase();
        const userValue = value.toLowerCase();
        if (title.indexOf(userValue) !== -1) payload.push(d);
      });

      resolve(payload);
    });
  };

  const renderPlaceholder = () => {
    const style = value && !focused ? { color: "var(--ripley-lavanda)" } : null;
    return <span style={style}>{placeholder}</span>;
  };

  const renderError = () => {
    if (!error) return;
    return <span className={styles["input-container-error"]}>{error}</span>;
  };

  const renderList = () => {
    if (value.length === 0) return;

    return (
      <div className={styles.autocomplete}>
        <ul>
          {list.map(({ title, code }) => (
            <li key={`list-item-${code}`}>
              <button
                onClick={() => {
                  setList([]);
                  onChange(title);
                }}
              >
                <span>{title}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <>
      <div
        className={styles["input-container"]}
        style={focused ? { border: "1.5px solid #5E388A" } : null}
      >
        <label className={styles["pure-material-textfield-filled"]}>
          <input
            name={name}
            ref={inputRef}
            placeholder=" "
            spellCheck="false"
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            value={value}
            onChange={async (e) => {
              onChange(e.target.value);
              const results = await handleList();
              console.log(results);
              setList(results);
            }}
            type={type}
          />
          {renderPlaceholder()}
        </label>
        {renderList()}
      </div>
      {renderError()}
    </>
  );
};

export default CustomAutoComplete;
